module.exports = __webpack_public_path__ + "img/template.fb697cf8.svg";